import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client/react";

const ALLOWED_OBJECT_TYPES_QUERY = gql`
  query allowedObjectTypes {
    allowedObjectTypes
  }
`;

/**
 * Formats a PascalCase model name to a human-readable label.
 * e.g. "TournamentTeam" -> "Tournament Team"
 */
function formatObjectTypeLabel(modelName: string): string {
  return modelName.replace(/([a-z])([A-Z])/g, "$1 $2");
}

export function useAllowedObjectTypes() {
  const { data, loading } = useQuery<{ allowedObjectTypes: string[] }>(
    ALLOWED_OBJECT_TYPES_QUERY,
  );

  const options = (data?.allowedObjectTypes ?? []).map((type) => ({
    label: formatObjectTypeLabel(type),
    value: type,
  }));

  return { options, loading };
}
